export const STANDARD = 'standard';
export const LOGO_FOCUSED = 'logo-focused';
export const CURVED = 'curved';
